import { gql } from '@apollo/client';

export const REQUEST_ATHLETE_CONNECTION = gql`
  mutation RequestAthleteConnection($email: String!) {
    requestAthleteConnection(email: $email) {
      _id
      status
      athlete {
        _id
        firstName
      }
    }
  }
`;

export const RESPOND_TO_COACH_REQUEST = gql`
  mutation RespondToCoachRequest($requestId: ID!, $accept: Boolean!) {
    respondToCoachRequest(requestId: $requestId, accept: $accept) {
      _id
      status
    }
  }
`;
